import { render, staticRenderFns } from "./ErrorMessageSettingContainer.vue?vue&type=template&id=84480e58&scoped=true&"
import script from "./ErrorMessageSettingContainer.vue?vue&type=script&lang=js&"
export * from "./ErrorMessageSettingContainer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorMessageSettingContainer.vue?vue&type=style&index=0&id=84480e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84480e58",
  null
  
)

export default component.exports